import axios from '../../util/http-common'

function normalizeFeaturesMap (features) {
  const normalized = {}
  Object.keys(features || {}).forEach(key => {
    normalized[String(key).toLowerCase()] = !!features[key]
  })
  return normalized
}

const state = {
  companyId: 0,
  version: 0,
  features: {},
  loaded: false,
  loading: false,
  pickerActive: false,
  pickerReturnPath: null,
  pendingPick: null,
}

const mutations = {
  setFeatures (state, { companyId, version, features }) {
    state.companyId = companyId || 0
    state.version = version || 0
    // Keys are matched case-insensitively: normalize here so v-feature-key
    // markers don't have to exactly match the backend's stored casing.
    state.features = normalizeFeaturesMap(features)
    state.loaded = true
  },
  reset (state) {
    state.companyId = 0
    state.version = 0
    state.features = {}
    state.loaded = false
  },
  setPickerActive (state, { active, returnPath }) {
    state.pickerActive = !!active
    state.pickerReturnPath = active ? (returnPath || null) : null
  },
  setPendingPick (state, payload) {
    state.pendingPick = payload || null
  },
}

const actions = {
  async loadMyFeatures ({ commit, state }) {
    if (state.loading) {
      return
    }

    state.loading = true
    try {
      const response = await axios.get('company-features/me')
      const data = response.data?.data ?? response.data
      commit('setFeatures', data || {})
    } catch (error) {
      // Leave previous state in place; UI falls back to allowing unknown/unfetched features.
    } finally {
      state.loading = false
    }
  },

  startPicker ({ commit }, returnPath) {
    commit('setPickerActive', { active: true, returnPath })
  },

  stopPicker ({ commit }) {
    commit('setPickerActive', { active: false })
  },

  consumePendingPick ({ commit, state }) {
    const payload = state.pendingPick
    commit('setPendingPick', null)
    return payload
  },
}

const getters = {
  hasFeature: state => key => {
    if (!key) {
      return true
    }
    const normalizedKey = String(key).toLowerCase()
    if (!Object.prototype.hasOwnProperty.call(state.features, normalizedKey)) {
      return true
    }
    return !!state.features[normalizedKey]
  },
  isLoaded: state => state.loaded,
  pickerActive: state => state.pickerActive,
  pickerReturnPath: state => state.pickerReturnPath,
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
